import React, { useEffect } from 'react';
import { Breadcrumb, Col, Skeleton } from 'antd';
import { RouteComponentProps } from 'react-router';
import { CommonLayout } from 'common/components/Layouts/CommonLayout';
import { ELayoutSize } from 'common/const/common.const';
import { ERoutesPrivate } from 'common/models/routesModel';
import { ECommonFormType } from 'common/models/commonModel';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { EBitecoinPageTabKeys } from 'app/pages/Franchisor/BitecoinPage';
import {
  addBitecoinReward,
  deleteBitecoinReward,
  getBitecoinRewardById,
  setBitecoinRewardModel,
  updateBitecoinReward,
} from 'app/store/reducers/bitecoin.reducer';
import { IBitecoinRewardCreateParams, IBitecoinRewardUpdateParams } from 'entities/Bitecoin/Bitecoin.models';
import { BitecoinRewardForm } from 'entities/Bitecoin/components/BitecoinRewardForm';
import { BitecoinRewardFormSkeleton } from 'entities/Bitecoin/components/BitecoinRewardFormSkeleton';

interface IParams {
  id?: string;
}

type AllProps = RouteComponentProps<IParams>;

export const BitecoinRewardPage: React.FC<AllProps> = ({ match }) => {
  const dispatch = useAppDispatch();
  const { bitecoinRewardModel, bitecoinRewardModelLoading } = useAppSelector((state) => state.bitecoin);
  const { params } = match;
  const { id } = params;
  const rewardName = bitecoinRewardModel?.name;
  const isEdit = !!id;
  const typeForm = isEdit ? ECommonFormType.Update : ECommonFormType.Add;

  const addReward = (data: IBitecoinRewardCreateParams) => {
    dispatch(addBitecoinReward(data));
  };

  const updateReward = (data: IBitecoinRewardUpdateParams) => {
    if (id) {
      dispatch(updateBitecoinReward(id, data));
    }
  };

  const deleteReward = () => {
    const { params } = match;
    const { id } = params;

    if (id) {
      dispatch(deleteBitecoinReward(id));
    }
  };

  useEffect(() => {
    const { params } = match;
    const { id } = params;

    if (id) {
      dispatch(getBitecoinRewardById(id));
    }

    return () => dispatch(setBitecoinRewardModel(null));
  }, []);

  return (
    <CommonLayout typeLayout={ELayoutSize.Large} classStyle="mt-10 pb-10">
      <Col span={14}>
        <Breadcrumb className="fs-sm font-weight-5 font-family__default mb-8">
          <Breadcrumb.Item href={`${ERoutesPrivate.Bitecoin}?tab=${EBitecoinPageTabKeys.RewardItems}`}>
            Reward Items
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {isEdit ? (
              !bitecoinRewardModelLoading ? (
                rewardName
              ) : (
                <Skeleton.Input active style={{ width: '200px' }} size="small" />
              )
            ) : (
              'Add new reward'
            )}
          </Breadcrumb.Item>
        </Breadcrumb>
        {!bitecoinRewardModelLoading || !isEdit ? (
          <BitecoinRewardForm
            typeForm={typeForm}
            createReward={addReward}
            updateReward={updateReward}
            deleteReward={deleteReward}
          />
        ) : (
          <BitecoinRewardFormSkeleton isEdit={isEdit} />
        )}
      </Col>
    </CommonLayout>
  );
};
